import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import Logo from "../components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        if (r.data?.is_admin) navigate("/admin", { replace: true });
        else setChecking(false);
      })
      .catch(() => setChecking(false));
  }, [navigate]);

  const onLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="min-h-screen bg-ivory flex flex-col">
      <header className="container-prose py-8">
        <Logo />
      </header>
      <main className="flex-1 container-prose flex items-center">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 w-full items-center">
          <div className="lg:col-span-7">
            <p className="overline">Admin · CMS</p>
            <h1
              className="h1-display mt-4 text-5xl sm:text-6xl text-ink"
              data-testid="admin-login-title"
            >
              Sign in to manage <br />
              <span className="italic text-forest">karamsodhi.com</span>
            </h1>
            <p className="mt-6 body-prose text-ink/70 max-w-lg text-base sm:text-lg">
              Add testimonials, upload gallery images, publish essays and review inquiries.
              Access is restricted to authorised emails only.
            </p>

            {checking ? (
              <p className="mt-8 text-sm text-ink/50">Checking session…</p>
            ) : (
              <button
                type="button"
                onClick={onLogin}
                data-testid="admin-google-login-btn"
                className="mt-10 inline-flex items-center gap-3 px-7 py-4 bg-ink text-ivory text-[12px] uppercase tracking-[0.22em] font-medium hover:bg-forest transition-colors"
              >
                Continue with Google
              </button>
            )}
          </div>
          <div className="lg:col-span-5 hidden lg:block">
            <div className="aspect-[4/5] bg-ink/5 relative overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1629839773973-656704f27e56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
                alt=""
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 ring-1 ring-ink/15" />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
